/* eslint-disable react/prop-types */
import React from 'react';
import { styled, Separator } from '@ublend-npm/aulaui-core';

const DateSeparatorContainer = styled('div')(() => ({
  position: 'relative',
  height: '24px',
  paddingBottom: '24px',
}));

const LabelContainer = styled('p')(() => ({
  position: 'absolute',
  top: '-15px',
  width: '100%',
  height: '100%',
  textAlign: 'center',
  margin: 0,
}));

const DateLabel = styled('span')(({ theme }) => ({
  fontSize: '.75rem',
  fontWeight: 500,
  lineHeight: '30px',
  width: '232.63px',
  height: '29px',
  padding: '4px 25px',
  color: theme.palette.primary.main,
  backgroundColor: theme.palette.background.paper,
  textTransform: 'uppercase',
  letterSpacing: '0.14px',
  fontFamily: 'Roboto, sans-serif',
}));

const formatDateHeader = (date) => {
  const dateObj = new Date(date);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Check if it's today
  if (dateObj.toDateString() === today.toDateString()) {
    return 'TODAY';
  }

  // Check if it's yesterday
  if (dateObj.toDateString() === yesterday.toDateString()) {
    return 'YESTERDAY';
  }

  // Format as "13th DECEMBER 2024"
  const day = dateObj.getDate();
  const month = dateObj
    .toLocaleString('en-US', { month: 'long' })
    .toUpperCase();
  const year = dateObj.getFullYear();

  // Add ordinal suffix to day
  const ordinal = (n) => {
    const s = ['th', 'st', 'nd', 'rd'];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  return `${ordinal(day)} ${month} ${year}`;
};

export default React.memo(({ date }) => (
  <DateSeparatorContainer>
    <Separator sx={{ mt: '20px', borderBottomWidth: '1px' }} />
    <LabelContainer>
      <DateLabel>{formatDateHeader(date)}</DateLabel>
    </LabelContainer>
  </DateSeparatorContainer>
));
